import React from 'react'
import ReactDOM from 'react-dom'
import Routes from './presentation/components/routes/routes'
import { GlobalStyle } from './presentation/styles/global'
import { CategoryFarmProvider } from './presentation/contexts/category-farm-context'
import { ModalInfoProvider } from './presentation/contexts/modal-info-context'

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <CategoryFarmProvider>
      <ModalInfoProvider>
        <Routes />
      </ModalInfoProvider>
    </CategoryFarmProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
